import { React, useRef, useEffect, useState } from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import Lottie from 'lottie-react';

import TotalModalWrapper from '../../../Share/Normal/TotalModalWrapper';
import FetchModule from '../../../Share/Network/FetchModule';
import TimeInput from '../../../../Component/ClassManageComponent/TimeInput.js';
import RepeatSelect from '../../../../Component/ClassManageComponent/RepeatSelect.js';
import RepeatWeekSetting from '../../../../Component/ClassManageComponent/RepeatWeekSetting.js';
import NewCalenderInput from '../../../../Component/ClassManageComponent/NewCalenderInput.js';
import NewClassSelectBox from '../../../../Component/ClassManageComponent/NewClassSelectBox.js';
import MaxBookedInput from '../../../../Component/ClassManageComponent/MaxBookedInput.js';
import ReservedMemberInfoBox from './ReservedMemberInfoBox.js';
import QueuedMemberInfoBox from './QueuedMemberInfo.js';

import WhiteTrashIcon from '../../../../image/WhiteTrashIcon.png';
import WhiteArrowImage from '../../../../image/WhiteArrow.png';
import WhiteUnLockPath from '../../../../image/UnLock.png';
import WhiteLockPath from '../../../../image/Lock.png';
import EmptySign from '../../../../image/EmptySign.png';
import Check from '../../../../image/Check.png';
import LoadingAnimation from '../../../../Animation/LoadingAnimation.json';
import ClassSaveLoadingView from './ClassSaveLoadingView.js';
import TeacherSelectBox from '../../../../Component/ClassManageComponent/TeacherSelectBox.js';
import { useLanguage } from '../../../../Context/LanguageContext';

export default function ClassAddModal(props) {
  const {
    date,
    scheduleData,
    scheduleId,
    teachers,
    onClickDeleteButton,
    cancel,
    options,
    clickedSchedule,

    changedTeacherRendering,
    setChangedTeacherRendering,
    defaultClassTime,
    defaultClassDate,
    defaultApplyWeek
  } = props;

  const history = useHistory();
  const { t } = useLanguage();

  const [isClicked, setIsClicked] = useState(true);
  const [selectedLesson, setSelectedLesson] = useState({ id: -1, name: t('classManage.selectOption'), time: 0, maxBookedPeople: 0 });
  const [coachNames, setCoachNames] = useState([]);
  const [selectedTeachers, setSelectedTeachers] = useState([]);
  const [initialTeacherIds, setInitialTeacherIds] = useState(''); // 모달 열렸을 때의 초기 teacherIds

  const [startDate, setStartDate] = useState(moment().format('YYYY.MM.DD'));
  const [originalStartDate, setOriginalStartDate] = useState(moment().format('YYYY-MM-DDTHH:mm:ss'));
  const [endDate, setEndDate] = useState('');
  const [maxBookedPeople, setMaxBookedPeople] = useState(0);

  const [sunday, setSunday] = useState(false);
  const [monday, setMonday] = useState(false);
  const [tuesday, setTuesday] = useState(false);
  const [wednesday, setWednesday] = useState(false);
  const [thursday, setThursday] = useState(false);
  const [friday, setFriday] = useState(false);
  const [saturday, setSaturday] = useState(false);

  const [all, setAll] = useState(true);
  const [one, setOne] = useState(true);
  const [two, setTwo] = useState(true);
  const [three, setThree] = useState(true);
  const [four, setFour] = useState(true);
  const [five, setFive] = useState(true);

  const [isClickedLock, setIsClickedLock] = useState(false);
  const [reserves, setReserves] = useState([]);
  const [queues, setQueues] = useState([]);
  const [maxQueue, setMaxQueue] = useState(20);

  const [rendering, setRendering] = useState(false);
  const [isInProgress, setIsInProgress] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const StartCalenderRef = useRef();
  const TimeRef = useRef();
  const RepeatRef = useRef();
  const RepeatWeekRef = useRef();
  const EndCalenderRef = useRef();

  // 수업 및 스케줄 정보 세팅 //
  useEffect(() => {
    if (scheduleId === -1) {

      if (defaultClassTime !== '') TimeRef.current.setValue(defaultClassTime);
      if (defaultClassDate !== '') StartCalenderRef.current.setValue(defaultClassDate.replaceAll('.', '-'));
      if (defaultApplyWeek !== '') RepeatRef.current.setValue(defaultApplyWeek);

      return;
    }

    for (let i = 0; i < scheduleData.length; i++) {
      if (scheduleData[i].scheduleId === scheduleId) {

        for (let j = 0; j < options.length; j++) {
          if (scheduleData[i].classId === options[j].id) {
            setSelectedLesson(options[j]);
            break;
          }
        }

        StartCalenderRef.current.setValue(date.format('YYYY-MM-DD'));
        setOriginalStartDate(scheduleData[i].classDate);
        TimeRef.current.setValue(scheduleData[i].classTime);
        RepeatRef.current.setValue(scheduleData[i].applyWeek);
        RepeatWeekRef.current.setValue(scheduleData[i].repeatWeek);

        if (scheduleData[i].endDate === '9999-12-31T00:00:00' || scheduleData[i].endDate === '9999-12-31T23:59:59') setIsClicked(true);
        else {
          setIsClicked(false);
          EndCalenderRef.current.setValue(scheduleData[i].endDate.split('T')[0]);
        }
      }
    }
  }, [scheduleData, scheduleId, options, date, defaultClassTime, defaultClassDate, defaultApplyWeek])

  // 수업 시작일과 종료일 검사 //
  useEffect(() => {
    if (startDate === '' || endDate === '') return;

    if (endDate < startDate) {
      alert(t('classManage.alertInvalidEndDate'));
      setEndDate(startDate);
      return;
    }

  }, [startDate, endDate])

  // 수업 담당 코치 뷰 정리 //
  useEffect(() => {
    if (selectedLesson.id === -1) return;

    const MAX_WIDTH_PX = 111;
    const CHAR_WIDTH_PX = 14;
    let teacherNames = selectedLesson.teachers;
    let isCanceledSchedule = false;

    if (clickedSchedule?.isChangedTeachers !== undefined) isCanceledSchedule = clickedSchedule.isChangedTeachers;

    if (isCanceledSchedule && (clickedSchedule.lessonId === selectedLesson.id)) {
      teacherNames = clickedSchedule.teacherNames;
    }
    // 코치 이름 표시 (너비 제한 적용)
    const coachNames = [];

    let totalLength = 0;

    for (let i = 0; i < teacherNames.length; i++) {
      const name = teacherNames[i];
      const newLength = totalLength + name.length;

      if ((newLength * CHAR_WIDTH_PX < MAX_WIDTH_PX) || i === 0) {
        coachNames.push(name);
        totalLength = newLength;
      }
      else {
        const remaining = teacherNames.length - i;

        if (remaining > 0) coachNames.push(`+${remaining}`);
        break;
      }
    }

    // 선택된 코치 객체 매핑 (Map 사용으로 O(n) 복잡度)
    const teacherMap = new Map(teachers.map(t => [t.teacherName, t]));
    const selectedTeachers = teacherNames
      .map(name => teacherMap.get(name))
      .filter(Boolean);

    setCoachNames(coachNames);
    setSelectedTeachers(selectedTeachers);

    // 초기 teacherIds 저장 (모달 열렸을 때의 상태)
    if (scheduleId !== -1 && selectedTeachers.length > 0) {
      const initialIds = selectedTeachers.map(t => t.teacherId).join(',');
      setInitialTeacherIds(initialIds);
    }
  }, [selectedLesson, teachers, clickedSchedule, scheduleId])

  // 수업 시간뷰 정리 및 API 호출 //
  useEffect(() => {
    if (scheduleId === -1) {
      setIsLoading(false);
      return;
    }

    let requestData = {
      scheduleId: scheduleId,
      classDate: date.format('YYYY-MM-DDT00:00:00')
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('reserve/status', 'POST', requestData);
        if (responseData.status === 200) {
          setIsClickedLock(responseData.data.isLock);
          setReserves(responseData.data.reserveMembers);
          setQueues(responseData.data.queueMembers);
          setMaxQueue(responseData.data.maxQueue);

          // 최대예약인원 변경 내역이 존재할 경우 //
          if (responseData.data.modifiedMaxBookedPeople !== -1) setMaxBookedPeople(responseData.data.modifiedMaxBookedPeople);
          // 최대 예약인원 변경 내역이 없을경우 //
          else setMaxBookedPeople(selectedLesson.maxBookedPeople);

          setIsLoading(false);
        }
        else setIsLoading(false);
      }
    )();

  }, [scheduleId, date, selectedLesson, rendering])

  // 회원 전화번호 표시 //
  function onViewUserPhone(phone) {
    if (phone === undefined || phone === '') return t('classManage.alertNoPhone');
    else return phone.slice(0, 3) + '-' + phone.slice(3, 7) + '-' + phone.slice(7, 11);
  }

  // 출석 버튼 텍스트 결정 //
  function onCalcButtonText(data) {
    if (data.status === 1 || data.status === 2) return t('classManage.attendanceConfirmed');
    else return t('classManage.attendanceCheck');
  }

  // 수업 개설 안내 문구 결정 //
  function decideTooltipLessonAndStartDateText() {
    let lessonName = selectedLesson.name === t('classManage.selectOption') ? '' : selectedLesson.name;
    let classDate = moment(startDate, 'YYYY.MM.DD').format(t('classManage.dateFormatTooltip'));

    return t('classManage.tooltipClassFrom', { lesson: lessonName, date: classDate });
  }

  // 수업 개설 안내 문구 결정 //
  function decideTooltipApplyWeekText() {
    let applyWeekArr = [];

    if (monday) applyWeekArr.push(t('classManage.dayMonShort'));
    if (tuesday) applyWeekArr.push(t('classManage.dayTueShort'));
    if (wednesday) applyWeekArr.push(t('classManage.dayWedShort'));
    if (thursday) applyWeekArr.push(t('classManage.dayThuShort'));
    if (friday) applyWeekArr.push(t('classManage.dayFriShort'));
    if (saturday) applyWeekArr.push(t('classManage.daySatShort'));
    if (sunday) applyWeekArr.push(t('classManage.daySunShort'));

    let applyWeek = applyWeekArr.join(', ');

    return applyWeek;
  }

  // 수업 개설 안내 문구 결정 //
  function decideTooltipApplyWeekFormatText() {
    let applyWeekArr = [];

    if (monday) applyWeekArr.push(t('classManage.dayMonShort'));
    if (tuesday) applyWeekArr.push(t('classManage.dayTueShort'));
    if (wednesday) applyWeekArr.push(t('classManage.dayWedShort'));
    if (thursday) applyWeekArr.push(t('classManage.dayThuShort'));
    if (friday) applyWeekArr.push(t('classManage.dayFriShort'));
    if (saturday) applyWeekArr.push(t('classManage.daySatShort'));
    if (sunday) applyWeekArr.push(t('classManage.daySunShort'));

    let applyWeek = applyWeekArr.join(', ');

    if (applyWeek === '') return '';
    else return t('classManage.tooltipDaySuffix');
  }

  // 수업 개설 안내 문구 결정 //
  function decideTooltipRepeatWeekText() {
    let repeatWeekArr = [];

    if (one) repeatWeekArr.push('1주 차');
    if (two) repeatWeekArr.push('2주 차');
    if (three) repeatWeekArr.push('3주 차');
    if (four) repeatWeekArr.push('4주 차');
    if (five) repeatWeekArr.push('5주 차');

    let repeatWeek = repeatWeekArr.join(', ');

    return repeatWeek;
  }

  // 수업 개설 안내 문구 결정 //
  function decideTooltipRepeatWeekFormatText() {
    let repeatWeekArr = [];

    if (one) repeatWeekArr.push('1주 차');
    if (two) repeatWeekArr.push('2주 차');
    if (three) repeatWeekArr.push('3주 차');
    if (four) repeatWeekArr.push('4주 차');
    if (five) repeatWeekArr.push('5주 차');

    let repeatWeek = repeatWeekArr.join(', ');

    if (repeatWeek === '') return '';
    else return t('classManage.tooltipRepeatWeekSuffix');
  }

  // 수업 개설 안내 문구 결정 //
  function decideTooltipEndDateText() {
    if (endDate === '') return t('classManage.tooltipIndefinite');
    else return t('classManage.tooltipRepeatUntil', { date: moment(endDate, 'YYYY.MM.DD').format(t('classManage.dateFormatTooltip')) });
  }

  function CalenderClick(className) {
    if (className === 'StartCalender') EndCalenderRef.current.closeCalender();
    else StartCalenderRef.current.closeCalender();
  }

  function onClickSaveButton() {
    let storeId = window.sessionStorage.getItem('StoreId');
    let lessonId = selectedLesson.id;
    let classDate = StartCalenderRef.current.getValue();
    let classTime = TimeRef.current.getValue();
    let applyWeek = RepeatRef.current.getValue();
    let repeatWeek = RepeatWeekRef.current.getValue();
    let endDate = isClicked ? '9999-12-31' : EndCalenderRef.current.getValue();

    if (lessonId === undefined || lessonId === -1) {
      alert(t('classManage.alertSelectClass'));
      return;
    }
    else if (classTime === "") {
      alert(t('classManage.alertSetClassTime'));
      return;
    }
    else if ((classTime.split('-')[0] > classTime.split('-')[1]) || classTime.length !== 11) {
      alert(t('classManage.alertInvalidTime'));
      return;
    }
    else if (classDate === '') {
      alert(t('classManage.alertSetClassDate'));
      return;
    }
    else if (applyWeek === '') {
      alert(t('classManage.alertSelectRepeat'));
      return;
    }
    else if (repeatWeek === '') {
      alert(t('classManage.alertSelectRepeatWeek'));
      return;
    }
    // 끝나는 날짜가 과거이거나 같을경우 //
    else if (classDate >= endDate) {
      endDate = moment(classDate, 'YYYY.MM.DD').clone().add(1, 'days').format('YYYY.MM.DD');
    }

    if (isInProgress) {
      alert(t('classManage.alertSaving'));
      return;
    }

    setIsInProgress(true);

    // 브레이크 타임 추가인 경우 //
    if (selectedLesson.id === -2) {
      let requestData = {
        classTime: classTime,
        classDate: classDate.replaceAll('.', '-') + 'T' + '00:00:00',
        applyWeek: applyWeek,
        repeatWeek: repeatWeek,
        endDate: endDate.replaceAll('.', '-') + 'T23:59:59'
      }

      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('breaktime/save', 'POST', requestData);

          if (responseData.status === 200) {
            setIsInProgress(false);
            cancel();
          }
          else if (responseData.status === 201) {
            alert(t('classManage.alertDuplicateClass'));
            setIsInProgress(false);
          }
          else if (responseData.status === 401) history.push('/');
        }
      )();
    }
    // 신규 등록
    else if (scheduleId === -1) {
      let data = {
        storeId: storeId,
        lessonId: lessonId,
        classTime: classTime,
        classDate: classDate.replaceAll('.', '-') + 'T' + classTime.split('-')[0] + ':00',
        applyWeek: applyWeek,
        repeatWeek: repeatWeek,
        endDate: endDate.replaceAll('.', '-') + 'T23:59:59'
      }

      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('schedule/save/', 'POST', data);

          if (responseData.status === 200) {
            setIsInProgress(false);
            cancel();
          }
          else if (responseData.status === 201) {
            alert(t('classManage.alertDuplicateClass'));
            setIsInProgress(false);
          }
          else if (responseData.status === 401) history.push('/');
          else alert(responseData.error);
        }
      )();
    }
    // 데이터 수정
    else {
      if (selectedTeachers.length === 0) {
        alert(t('classManage.alertSetCoach'));
        setIsInProgress(false);
        return;
      }

      const teacherIds = selectedTeachers.map(teacher => teacher.teacherId).join(',');
      const teacherNames = selectedTeachers.map(teacher => teacher.teacherName).join(',');

      // 순서 상관없이 teacherIds 비교 (모달 열렸을 때의 초기값과 비교)
      const currentIds = teacherIds.split(',').sort().join(',');
      const originalIds = initialTeacherIds.split(',').sort().join(',');
      const isTeacherIdsChanged = currentIds !== originalIds;

      const fetchModule = new FetchModule();
      const promises = [];

      // 수업에서 코치님 변경시 //
      if (isTeacherIdsChanged) {
        let requestData = {
          lessonId: lessonId,
          scheduleId: scheduleId,
          teacherIds: teacherIds,
          teacherNames: teacherNames,
          classTime: classTime,
          classDate: date.format('YYYY-MM-DDT00:00:00')
        }

        promises.push(fetchModule.postDataVersion2('changed_teacher/save', 'POST', requestData));
      }

      // 원본 수업 정원과 같지 않을경우 실행 //
      if (maxBookedPeople !== selectedLesson.maxBookedPeople) {
        let requestData = {
          scheduleId: scheduleId,
          classDate: date.format('YYYY-MM-DDT00:00:00'),
          modifyMaxBookedPeople: maxBookedPeople
        }

        promises.push(fetchModule.postDataVersion2('max_booked/save', 'POST', requestData));
      }

      let data = {
        scheduleId: scheduleId,
        lessonId: lessonId,
        classTime: classTime,
        startDate: classDate.replaceAll('.', '-') + 'T' + classTime.split('-')[0] + ':00',
        classDate: date.format('YYYY-MM-DDT00:00:00'),
        changeApplyWeek: date.format('ddd,'),
        repeatWeek: repeatWeek,
        endDate: endDate.replaceAll('.', '-') + 'T23:59:59'
      }

      const index = scheduleData.findIndex(item => item.scheduleId === scheduleId);

      if (data.lessonId !== scheduleData[index].lessonId
        || data.classTime !== scheduleData[index].classTime
        || data.repeatWeek !== scheduleData[index].repeatWeek
        || data.endDate !== scheduleData[index].endDate) {
        promises.push(fetchModule.postDataVersion2('schedule/modify', 'POST', data));
      }

      // 모든 API 호출 완료 대기
      (
        async () => {
          const results = await Promise.all(promises);

          // 에러 체크
          const failedResponse = results.find(res => res.status !== 200);
          if (failedResponse) {
            if (failedResponse.status === 401) history.push('/');
            else {
              alert(failedResponse.error);
              setIsInProgress(false);
            }
            return;
          }

          // 코치 변경이 있었다면 렌더링 상태 업데이트
          if (isTeacherIdsChanged) {
            setChangedTeacherRendering(!changedTeacherRendering);
          }

          setIsInProgress(false);
          cancel();
        }
      )();
    }
  }

  // Select Box 클릭시 다른 Select Box 끄기
  function selectClickFn(className) {
    if (className === 'category') {
      StartCalenderRef.current.closeCalender();
      EndCalenderRef.current.closeCalender();
    }
    else if (className === 'lesson') {
      StartCalenderRef.current.closeCalender();
      EndCalenderRef.current.closeCalender();
    }
    else if (className === 'start') {
      EndCalenderRef.current.closeCalender();
    }
    else if (className === 'end') {
      StartCalenderRef.current.closeCalender();
    }
  }

  // 삭제버튼 클릭시
  function onClickDelete() {
    let deletedData = {
      scheduleId: scheduleId,
      classDate: date.format('YYYY-MM-DD')
    }

    onClickDeleteButton(deletedData, 'DetailModal');
  }

  // 브레이크 타임 합산으로 인한 컬럼 배경색 변경 //
  function onCalcLessonInfoColumnBackground() {
    if (selectedLesson.id === -2) return '#E0E0E0';
    else return '#FFFFFF';
  }

  // 수업 정원 늘리기 클릭시 //
  function onClickUpMaxBookedPeople() {
    setMaxBookedPeople(maxBookedPeople + 1);
  }

  // 수업 정원 줄이기 클릭시 //
  function onClickDownMaxBookedPeople() {
    if (maxBookedPeople > 0) setMaxBookedPeople(maxBookedPeople - 1);
  }

  // 회원 이름 또는 사진 클릭시 //
  function onClickMemberProfileOrText(data) {
    if (data.memberId === 0 && data.userId.includes('Guest-')) {
      alert(t('classManage.alertGuestNoAccess'));
      return;
    }
    else history.push('/member/valid/detail/' + data.memberId);
  }

  // 회원 예약 취소 버튼 클릭시 //
  function onClickMemberExceptButton(index) {
    if (isInProgress) {
      alert(t('classManage.alertProcessing'));
      return;
    }

    setIsInProgress(true);

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postData('reserve/delete/manage/' + reserves[index].reserveId, 'POST');

        if (responseData.status === 200) {
          setRendering(!rendering);
          setIsInProgress(false);
        }
        else if (responseData.status === 401) history.push('/');
      }
    )();
  }

  // 출석 버튼 클릭시 //
  function onClickAttendanceButton(data) {
    if (data.status === 0 || data.status === 3) {
      let requestData = {
        reserveId: data.reserveId,
        status: 1
      }

      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('reserve/attendance/check/in_modal', 'POST', requestData);

          if (responseData.status === 200) {
            alert(t('classManage.alertAttendanceDone'));
            setRendering(!rendering);
          }
          else if (responseData.status === 401) history.push('/');
        }
      )();
    }
    else {
      let requestData = {
        reserveId: data.reserveId,
        status: 3
      }

      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('reserve/attendance/check/in_modal', 'POST', requestData);

          if (responseData.status === 200) {
            alert(t('classManage.alertAttendanceCanceled'));
            setRendering(!rendering);
          }
          else if (responseData.status === 401) history.push('/');
        }
      )();
    }
  }

  // 예약 대기에서 예약 추가 버튼 클릭시 //
  function onClickAddReserveOnQueue(data) {
    let requestData = {
      reserveQueueId: data.queueId
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('reserve/add/zone', 'POST', requestData);

        if (responseData.status === 200) {
          setRendering(!rendering);
        }
      }
    )();
  }

  // 예약 잠금 버튼 클릭시 //
  function onClickReserveLockButton() {
    if (isInProgress) {
      alert(t('classManage.alertProcessing'));
      return;
    }

    setIsInProgress(true);

    let requestData = {
      scheduleId: scheduleId,
      classDate: date.format('YYYY-MM-DDT00:00:00')
    }

    // 예약 잠금 풀기 //
    if (isClickedLock) {
      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('reserve/unlock', 'POST', requestData);

          if (responseData.status === 200) {
            setRendering(!rendering);
            setIsClickedLock(false);
            setIsInProgress(false);
          }
          else if (responseData.status === 201) {
            alert(t('classManage.alertInvalidAccess'));
            setIsInProgress(false);
          }
          else if (responseData.status === 401) history.push('/');
        }
      )();
    }
    // 예약 잠금하기 //
    else {
      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('reserve/lock', 'POST', requestData);

          if (responseData.status === 200) {
            setRendering(!rendering);
            setIsClickedLock(true);
            setIsInProgress(false);
          }
          else if (responseData.status === 401) history.push('/');
        }
      )();
    }
  }

  return (
    <TotalModalWrapper>
      {isInProgress && <ClassSaveLoadingView />}
      <ModalView isExistSchedule={scheduleId !== -1}>
        <TitleWrapper isExistSchedule={scheduleId !== -1}>
          {
            scheduleId === -1 ?
              <Title>{t('classManage.addClass')}</Title>
              :
              <Title>{t('classManage.classInfo')}</Title>
          }
          {
            scheduleId === -1 ?
              <DateText>{date.format('YYYY.MM.DD')}</DateText>
              :
              <DeleteButtonWrapper>
                <DeletedButton isExistSchedule={scheduleId !== -1} onClick={onClickDelete}>
                  <DeleteImage src={WhiteTrashIcon} />
                </DeletedButton>
              </DeleteButtonWrapper>
          }
        </TitleWrapper>
        <TotalWrapper>
          <TotalInnerWrapper>
            <LayerWrapper>
              <ComponentWrapper>
                <ComponentTitle>{t('classManage.labelClass')}</ComponentTitle>
                <NewClassSelectBox value={selectedLesson} setValue={setSelectedLesson} options={options} selectClickFn={() => selectClickFn('lesson')} />
              </ComponentWrapper>
            </LayerWrapper>
            <LayerWrapper>
              <ComponentWrapper>
                <ComponentTitle>{t('classManage.labelCoach')}</ComponentTitle>
                {
                  scheduleId === -1 ?
                    <TeacherBox>
                      {
                        coachNames.map((data, index) => (
                          <TeacherView key={'Teachers-' + index}>
                            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#FFFFFF'>{data}</Text>
                          </TeacherView>
                        ))
                      }
                    </TeacherBox>
                    :
                    <TeacherSelectBoxWrapper>
                      <TeacherSelectBox teachers={teachers} selectedTeachers={selectedTeachers} setSelectedTeachers={setSelectedTeachers} />
                    </TeacherSelectBoxWrapper>
                }
              </ComponentWrapper>
              <ComponentWrapper>
                <ComponentTitle>{t('classManage.labelCapacity')}</ComponentTitle>
                {
                  scheduleId === -1 ?
                    <LessonInfoBox backgroundColor={onCalcLessonInfoColumnBackground()}>
                      <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#000000'>{selectedLesson.maxBookedPeople}</Text>
                      <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#000000'>{t('system.people')}</Text>
                    </LessonInfoBox>
                    :
                    <MaxBookedInputWrapper>
                      <MaxBookedInput value={maxBookedPeople} setValue={setMaxBookedPeople} placeholder='0' />
                      <MaxBookedButton onClick={onClickUpMaxBookedPeople}>
                        <ArrowButtonImage isUp={true} src={WhiteArrowImage} />
                      </MaxBookedButton>
                      <MaxBookedButton onClick={onClickDownMaxBookedPeople}>
                        <ArrowButtonImage isUp={false} src={WhiteArrowImage} />
                      </MaxBookedButton>
                      <LockButton isLock={isClickedLock}>
                        <UnLock src={WhiteUnLockPath} isLock={isClickedLock} onClick={onClickReserveLockButton} />
                        <Lock src={WhiteLockPath} isLock={isClickedLock} onClick={onClickReserveLockButton} />
                      </LockButton>
                    </MaxBookedInputWrapper>
                }
              </ComponentWrapper>
            </LayerWrapper>
            <DivisionLine />
            <LayerWrapper>
              <ComponentWrapper>
                <ComponentTitle>{t('classManage.labelDateTime')}</ComponentTitle>
                <NewCalenderInput
                  ref={StartCalenderRef}
                  value={startDate}
                  setValue={setStartDate}
                  selectClickFn={() => selectClickFn('start')}
                  className='StartCalender'
                  clickFn={CalenderClick}
                  placeholder={t('classManage.placeholderStartDate')}
                  width='288px'
                  disabled={scheduleId !== -1} />
              </ComponentWrapper>
              <ComponentWrapper>
                <ComponentTitle>{t('classManage.labelTime')}</ComponentTitle>
                <TimeInput ref={TimeRef} placeholder="00:00 - 00:00" />
              </ComponentWrapper>
            </LayerWrapper>
            <LayerWrapper>
              <ComponentWrapper>
                <ComponentTitle>{t('classManage.labelRepeatSchedule')}</ComponentTitle>
                <RepeatSelect
                  ref={RepeatRef}
                  scheduleId={scheduleId}
                  date={date}
                  sunday={sunday}
                  setSunday={setSunday}
                  monday={monday}
                  setMonday={setMonday}
                  tuesday={tuesday}
                  setTuesday={setTuesday}
                  wednesday={wednesday}
                  setWednesday={setWednesday}
                  thursday={thursday}
                  setThursday={setThursday}
                  friday={friday}
                  setFriday={setFriday}
                  saturday={saturday}
                  setSaturday={setSaturday} />
              </ComponentWrapper>
              <ComponentWrapper>
                <LimitWrapper>
                  <ComponentTitleWrapper>
                    <ComponentTitle>{t('classManage.labelRepeatWeek')}</ComponentTitle>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#BDBDBD' cursor='default'>{t('classManage.labelBiweekly')}</Text>
                  </ComponentTitleWrapper>
                </LimitWrapper>
                <RepeatWeekSetting
                  ref={RepeatWeekRef}
                  all={all}
                  setAll={setAll}
                  one={one}
                  setOne={setOne}
                  two={two}
                  setTwo={setTwo}
                  three={three}
                  setThree={setThree}
                  four={four}
                  setFour={setFour}
                  five={five}
                  setFive={setFive} />
              </ComponentWrapper>
            </LayerWrapper>
            <LayerWrapper>
              <ComponentWrapper>
                <LimitWrapper>
                  <ComponentTitle>{t('classManage.labelEndDate')}</ComponentTitle>
                  <LimitButtonWrapper onClick={() => setIsClicked(!isClicked)}>
                    <LimitButton isClicked={isClicked}>
                      <CheckImage src={Check} isClicked={isClicked} />
                    </LimitButton>
                    <LimitText>{t('classManage.labelNoLimit')}</LimitText>
                  </LimitButtonWrapper>
                </LimitWrapper>
                <NewCalenderInput
                  ref={EndCalenderRef}
                  value={endDate}
                  setValue={setEndDate}
                  className='EndCalender'
                  selectClickFn={() => selectClickFn('end')}
                  clickFn={CalenderClick}
                  placeholder={t('classManage.placeholderEndDate')}
                  width='288px'
                  disabled={isClicked} />
              </ComponentWrapper>
            </LayerWrapper>
            {
              scheduleId !== -1 &&
              <LayerWrapper style={{ marginTop: '26px' }}>
                <TooltipTextBox style={{ width: '608px' }}>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#3E4148' cursor='default'>{decideTooltipLessonAndStartDateText()}</Text>
                  <TooltipTextWrapper>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#3E4148' cursor='default'>{decideTooltipApplyWeekText()}</Text>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#3E4148' cursor='default'>{decideTooltipApplyWeekFormatText()}</Text>
                  </TooltipTextWrapper>
                  <TooltipTextWrapper>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#3E4148' cursor='default'>{decideTooltipRepeatWeekText()}</Text>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#3E4148' cursor='default'>{decideTooltipRepeatWeekFormatText()}</Text>
                  </TooltipTextWrapper>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#3E4148' cursor='default'>{decideTooltipEndDateText()}</Text>
                </TooltipTextBox>
              </LayerWrapper>
            }
          </TotalInnerWrapper>

          {scheduleId !== -1 && <ReserveDivisionLine />}

          {
            scheduleId !== -1 &&
            <TotalReserveBoxWrapper>
              <StatusInfoBox>
                <MemberReserveListTitleWrapper>
                  <Text fontFamily='Poppins-Medium' fontSize={14} color='#777777' cursor='default'>{t('classManage.reservedMembers')}</Text>
                  <Text fontFamily='Poppins-Medium' fontSize={14} color='#777777' cursor='default'>{reserves.length} {t('system.people')} / {maxBookedPeople} {t('system.people')}</Text>
                </MemberReserveListTitleWrapper>
                {
                  isLoading ?
                    <LoadingStatusBox>
                      <LottieWrapper>
                        <Lottie animationData={LoadingAnimation} loop={true} />
                      </LottieWrapper>
                    </LoadingStatusBox>
                    :
                    reserves.length > 0 ?
                      <StatusScrollBox isExistQueue={queues.length > 0}>
                        {
                          reserves.map((memberData, index) => (
                            <ReservedMemberInfoBox
                              key={'Reserve-' + index}
                              memberData={memberData}
                              index={index}
                              totalLength={reserves.length}
                              onViewUserPhone={onViewUserPhone}
                              onCalcButtonText={onCalcButtonText}
                              onClickMemberProfileOrText={onClickMemberProfileOrText}
                              onClickMemberExceptButton={onClickMemberExceptButton}
                              onClickAttendanceButton={onClickAttendanceButton} />
                          ))
                        }
                      </StatusScrollBox>
                      :
                      <EmptyStatusBox>
                        <EmptyImage src={EmptySign} />
                        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#BDBDBD' cursor='default'>{t('classManage.reserveEmpty')}</Text>
                      </EmptyStatusBox>
                }
              </StatusInfoBox>
              {
                queues.length > 0 &&
                <StatusInfoBox style={{ marginTop: '8px' }}>
                  <MemberReserveListTitleWrapper>
                    <Text fontFamily='Poppins-Medium' fontSize={14} color='#777777' cursor='default'>{t('classManage.queueList')}</Text>
                    <Text fontFamily='Poppins-Medium' fontSize={14} color='#777777' cursor='default'>{queues.length} {t('system.people')} / {maxQueue} {t('system.people')}</Text>
                  </MemberReserveListTitleWrapper>
                  <QueueScrollBox>
                    {
                      queues.map((memberData, index) => (
                        <QueuedMemberInfoBox
                          key={'Queue-' + index}
                          memberData={memberData}
                          index={index}
                          onViewUserPhone={onViewUserPhone}
                          onClickMemberProfileOrText={onClickMemberProfileOrText}
                          onClickAddReserveOnQueue={onClickAddReserveOnQueue}
                        />
                      ))
                    }
                  </QueueScrollBox>
                </StatusInfoBox>
              }
            </TotalReserveBoxWrapper>
          }
        </TotalWrapper>
        <BottomWrapper isExistSchedule={scheduleId !== -1}>
          {
            scheduleId === -1 &&
            <TooltipTextBox>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#3E4148' cursor='default'>{decideTooltipLessonAndStartDateText()}</Text>
              <TooltipTextWrapper>
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#3E4148' cursor='default'>{decideTooltipApplyWeekText()}</Text>
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#3E4148' cursor='default'>{decideTooltipApplyWeekFormatText()}</Text>
              </TooltipTextWrapper>
              <TooltipTextWrapper>
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#3E4148' cursor='default'>{decideTooltipRepeatWeekText()}</Text>
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#3E4148' cursor='default'>{decideTooltipRepeatWeekFormatText()}</Text>
              </TooltipTextWrapper>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#3E4148' cursor='default'>{decideTooltipEndDateText()}</Text>
            </TooltipTextBox>
          }
          <ButtonWrapper>
            <ExitButton onClick={cancel}>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#3E4148' cursor='pointer'>{t('classManage.btnCancel')}</Text>
            </ExitButton>
            <SaveButton onClick={onClickSaveButton}>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' cursor='pointer'>{t('classManage.btnSave')}</Text>
            </SaveButton>
          </ButtonWrapper>
        </BottomWrapper>
      </ModalView>
    </TotalModalWrapper>
  )
}

const ModalView = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 20px 0px;

  // width: 644px;
  // width: 1105px;
  width: ${props => props.isExistSchedule ? `1105px` : `680px`};

  border-radius: 10px;
  box-shadow: 0px 40px 50px rgba(0, 0, 0, 0.1);

  background-color: #FFFFFF;
`;

const DivisionLine = styled.div`
  display: flex;
  flex-direction: column;

  margin: 8px 0px;

  // width: 588px;
  width: 640px;
  height: 1px;

  background-color: #ECECEC;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  // width: 588px;
  // width: 1056px;
  width: ${props => props.isExistSchedule ? `1056px` : `640px`};
`;

const Title = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 16px;

  color: #232323;

  margin: 0 0 0 0;
`;

const DateText = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: #232323;

  margin: 0 0 0 0;

  &:hover {
    cursor: default;
  }
`;

const DeleteButtonWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 52px;
  height: 24px;
`;

const DeletedButton = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin: ${props => props.isExistSchedule ? `-26px -64px 0px 0px` : `-26px -54px 0px 0px`};
  // margin: -26px -64px 0px 0px;

  width: 38px;
  height: 38px;

  border-radius: 0px 10px 0px 10px;
  background-color: #FF3131;

    opacity: 0.5;

  &:hover {
    cursor: pointer;
    // background-color: #D92828;
    opacity: 1;
  }

  transition: all 0.3s ease-in-out;
`;

const DeleteImage = styled.img`
  width: 26px;
  height: 26px;
`;

const TotalWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 30px;

  gap: 10px;
`;

const TotalInnerWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 10px;
`;

const TotalReserveBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 395px;

  gap: 10px;
`;

const ReserveDivisionLine = styled.div`
  width: 1px;
  height: 495px;

  border-radius: 2px;
  background-color: #D9D9D9;
`;

const StatusInfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
`;

const MemberReserveListTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
  height: 32px;
`;


const StatusScrollBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 16px;

  width: 100%;
  // height: 212px;
  height: ${props => props.isExistQueue ? '212px' : '434px'};
  
  overflow-y: scroll;
  overflow-x: none;

  gap: 4px;

  &::-webkit-scrollbar {
    width: 2px;
  }

  &::-webkit-scrollbar-thumb {
		border: 3px solid transparent;
		background-color: #DADADA;
		border-radius: 200px;
	}

  &::-webkit-scrollbar-track {
		background-color: #F0F0F0;
		border-radius: 200px;
	}
`;

const QueueScrollBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 8px;

  width: 100%;
  height: 212px;
  
  gap: 4px;

  overflow-y: scroll;
  overflow-x: none;

  &::-webkit-scrollbar {
    width: 2px;
  }

  &::-webkit-scrollbar-thumb {
		border: 3px solid transparent;
		background-color: #DADADA;
		border-radius: 200px;
	}

  &::-webkit-scrollbar-track {
		background-color: #F0F0F0;
		border-radius: 200px;
	}
`;

const LoadingStatusBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 16px;

  width: 100%;
  height: 434px;
`;


const EmptyStatusBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 434px;

  gap: 10px;
`;

const LayerWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  gap: 20px;

  // transition: all 0.3s ease-in-out;
`;

const ComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;
`;

const ComponentTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 4px;
`;

const ComponentTitle = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: #000000;

  margin: 0 0 0 0;
`;

const BottomWrapper = styled.div`
  display: flex;
  flex-direction: row;

  // justify-content: space-between;
  justify-content: ${props => props.isExistSchedule ? `flex-end` : `space-between`};
  align-items: flex-end;

  // margin-top: ${props => props.isExistReserve ? `0px` : `45px`};
  margin-top: 30px;

  // width: 640px;
  width: ${props => props.isExistSchedule ? `1056px` : `640px`};
  // width: 1056px;
`;

const TooltipTextBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  padding: 5px 16px;

  width: 374px;

  border-radius: 10px;
  background-color: #F5F6F8;
`;

const TooltipTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 10px;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 60px;
  height: 40px;

  border-radius: 10px;
  background-color: #F5F6F8;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const LimitWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const LimitButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 4px;
`;

const LimitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 16px;
  height: 16px;

  border: ${props => props.isClicked ? `1px solid #FF8B48` : `1px solid #DFDFDF`};
  border-radius: 2px;
  background-color: ${props => props.isClicked ? `#FF8B48` : `#FFFFFF`};

  transition: all 0.3s ease-in-out;

  &:hover{
    cursor: pointer;
  }
`;

const CheckImage = styled.img`
  width: 9px;
  height: 9px;

  opacity: ${props => props.isClicked ? 1 : 0};

  transition: all 0.3s ease-in-out;
`;

const LimitText = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: #000000;

  margin: 0 0 0 0;

  &:hover {
    cursor: pointer;
  }
`;

const SaveButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100px;
  height: 40px;

  border-radius: 10px;
  background-color: #5BD98A;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    background-color: #2BCB67;
  }
`;

const TeacherBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding: 0px 10px;
  margin-top: 8px;

  gap: 4px;

  width: 288px;
  height: 30px;

  border: 1px solid #B2B2B2;
  border-radius: 5px;
  background-color: #FFFFFF;

  &:hover {
    cursor: default;
  }
`;

const TeacherSelectBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  margin-top: 8px;

  width: 310px;
  height: 32px;
`;

const TeacherView = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: flex-start;

  padding: 0px 8px 0px 8px;

  max-width: 116px;
  height: 24px;

  border-radius: 6px;
  background-color: #FF8B48;

  overflow: hidden;
`;

const MaxBookedInputWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  margin-top: 8px;

  width: 310px;
`;

const MaxBookedButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 32px;
  height: 32px;

  border-radius: 5px;
  background-color: #CBCBCB;

  &:hover {
    cursor: pointer;
  }
`;

const LockButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 32px;
  height: 32px;

  border-radius: 5px;
  background-color: ${props => props.isLock ? `#D92828` : `#CBCBCB`};

  &:hover {
    cursor: pointer;
    background-color: #D92828;
  }

  transition: all 0.3s ease-in-out;
`;

const LessonInfoBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  padding: 0px 10px;
  margin-top: 8px;

  gap: 4px;

  // width: 154px;
  width: 288px;
  height: 30px;

  border: 1px solid #B2B2B2;
  border-radius: 5px;
  background-color: ${props => props.backgroundColor};

  &:hover {
    cursor: default;
  }
`;

const ArrowButtonImage = styled.img`
  width: 17px;
  height: 10px;

  -webkit-transform: ${props => props.isUp ? `rotate(180deg)` : `rotate(0deg)`};
`;

const Lock = styled.img`
  position: absolute;

  opacity: ${props => props.isLock ? 1 : 0};

  width: 15px;
  height: 20px;

  transition: all 0.3s ease-in-out;
`;

const UnLock = styled.img`
  opacity: ${props => props.isLock ? 0 : 1};

  width: 15px;
  height: 20px;

  transition: all 0.3s ease-in-out;
`;

const LottieWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 60px;
  height: 60px;
`;

const EmptyImage = styled.img`
  width: 148px;
  height: 62px;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }
`;

const PreText = styled.pre`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }
`;